(function () {
  function openCartDrawer(trigger) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return false;
    cartDrawer.open(trigger);
    return true;
  }

  function bindCartTrigger(trigger) {
    if (!trigger || trigger.dataset.cartDrawerBound === 'true') return;
    trigger.dataset.cartDrawerBound = 'true';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'dialog');

    trigger.addEventListener('click', function (event) {
      if (openCartDrawer(trigger)) {
        event.preventDefault();
      }
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.code === 'Space' || event.code === 'Enter') {
        if (openCartDrawer(trigger)) {
          event.preventDefault();
        }
      }
    });
  }

  function init() {
    const cartTriggers = document.querySelectorAll('[data-header-cart-trigger]');
    cartTriggers.forEach(bindCartTrigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
(function () {
  function openCartDrawer(trigger) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return false;
    cartDrawer.open(trigger);
    return true;
  }

  function bindCartTrigger(trigger) {
    if (!trigger || trigger.dataset.cartDrawerBound === 'true') return;
    trigger.dataset.cartDrawerBound = 'true';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'dialog');

    trigger.addEventListener('click', function (event) {
      if (openCartDrawer(trigger)) {
        event.preventDefault();
      }
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.code === 'Space' || event.code === 'Enter') {
        if (openCartDrawer(trigger)) {
          event.preventDefault();
        }
      }
    });
  }

  function init() {
    const cartTriggers = document.querySelectorAll('[data-header-cart-trigger]');
    cartTriggers.forEach(bindCartTrigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
(function () {
  function openCartDrawer(trigger) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return false;
    cartDrawer.open(trigger);
    return true;
  }

  function bindCartTrigger(trigger) {
    if (!trigger || trigger.dataset.cartDrawerBound === 'true') return;
    trigger.dataset.cartDrawerBound = 'true';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'dialog');

    trigger.addEventListener('click', function (event) {
      if (openCartDrawer(trigger)) {
        event.preventDefault();
      }
    });

    trigger.addEventListener('keydown', function (event) {
      if (event.code === 'Space' || event.code === 'Enter') {
        if (openCartDrawer(trigger)) {
          event.preventDefault();
        }
      }
    });
  }

  function init() {
    const cartTriggers = document.querySelectorAll('[data-header-cart-trigger]');
    cartTriggers.forEach(bindCartTrigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
